import Alpine from "alpinejs";

Alpine.data("annotationSelectors", () => ({
    checkedItems: [],
    allSelected: false,
    annotationSelectorInit() {
        const params = new URLSearchParams(window.location.search);
        const categories = params.get('annotation_categories');
        if (categories) {
            this.checkedItems = categories.split(',');
            const checkBoxes = document.querySelector('.c-annotation__filters').querySelectorAll('input[type="checkbox"]')
            checkBoxes.forEach(checkbox => {
                if (this.checkedItems.includes(checkbox.getAttribute("data-annotation-category-name"))) {
                    checkbox.checked = true;
                }
            })
            this.highlightAnnotations();
            this.applyToPageNavigationLinks(params)
        }
    },
    handleCheckbox(event) {
        const {target} = event;
        const listItem = target.closest("li")
        const value = target.getAttribute("data-annotation-category-name")
        if (value === 'all') {
            this.toggleAll()
        } else {

            if (listItem.classList.contains('c-annotation__list-item--parent')) {
                const children = listItem.querySelectorAll('input[type="checkbox"][name="annotation"]');
                children.forEach(child => {
                    const childValue = child.getAttribute("data-annotation-category-name");
                    child.checked = target.checked;

                    if (target.checked) {
                        this.addCheckedItem(childValue)
                    } else {
                        this.removeCheckedItem(childValue)
                    }
                });
            } else {
                if (target.checked) {
                    this.addCheckedItem(value)
                } else {
                    this.removeCheckedItem(value)
                }
            }
        }

        this.syncAllSelected();
        this.highlightAnnotations();
        this.updateUrlSearchParams();
    }
    ,
    addCheckedItem(value) {
        if (!this.checkedItems.includes(value)) {
            this.checkedItems.push(value);
        }
    },
    removeCheckedItem(value) {
        this.checkedItems = this.checkedItems.filter(item => item !== value);
    },
    syncAllSelected() {
        const categoryCheckboxes = document.querySelectorAll('input[type="checkbox"][name="annotation"][data-annotation-category-name]:not([data-annotation-category-name="all"])');
        const categoryNames = Array.from(categoryCheckboxes).map(cb => cb.getAttribute("data-annotation-category-name"));
        this.allSelected = categoryNames.length > 0 && categoryNames.every(name => this.checkedItems.includes(name));

        const allCheckbox = document.querySelector('input[data-annotation-category-name="all"]');
        if (allCheckbox) {
            allCheckbox.checked = this.allSelected;
        }
    },
    highlightAnnotations() {
        const transcript = document.getElementById('transcript');
        if (!transcript) {
            return
        }
        const annotations = transcript.querySelectorAll('.c-highlightable-annotation');
        annotations.forEach(annotation => {
            const categories = JSON.parse(annotation.getAttribute('data-annotation-categories'));
            if (this.checkedItems.filter(item => categories.includes(item)).length) {
                annotation.classList.add('c-highlight');
            } else {
                annotation.classList.remove('c-highlight');
            }
        });
    },
    toggleAll() {
        const checkboxes = document.querySelectorAll('input[type="checkbox"][name="annotation"]');
        const allCategoryNames = Array.from(checkboxes)
            .map(cb => cb.getAttribute("data-annotation-category-name"))
            .filter(name => name !== 'all');

        const allChecked = allCategoryNames.every(name => this.checkedItems.includes(name));
        const shouldCheck = !allChecked;

        this.checkedItems = shouldCheck ? [...allCategoryNames] : [];

        checkboxes.forEach(checkbox => {
            const name = checkbox.getAttribute("data-annotation-category-name");
            if (name !== 'all') {
                checkbox.checked = shouldCheck;
            }
        });

        this.allSelected = shouldCheck;

        // Reflect the "all" checkbox state
        const allCheckbox = document.querySelector('input[data-annotation-category-name="all"]');
        if (allCheckbox) {
            allCheckbox.checked = shouldCheck;
        }

        this.highlightAnnotations();
        this.updateUrlSearchParams();
    },
    updateUrlSearchParams() {
        const params = new URLSearchParams(window.location.search);
        params.delete('annotation_categories');
        const items = [...this.checkedItems];

        if (this.allSelected && !items.includes('all')) {
            items.unshift('all')
        }
        if (items.length) {
            params.set('annotation_categories', items.join(','));
        }

        this.applyToPageNavigationLinks(params)

        const url = new URL(window.location);
        url.search = params;
        window.history.pushState({}, '', url);
    },
    applyToPageNavigationLinks(params) {
        // Only mutate real anchors; current-page spans and disabled image arrows do not have hrefs.
        const navigationLinks = document.querySelectorAll([
            '.c-pagination a.c-pagination__link[href]',
            '.c-book-container__image .c-arrow a[href]',
        ].join(', '));

        navigationLinks.forEach(link => {
            const linkUrl = new URL(link.getAttribute('href'), window.location.href);
            const currentParams = new URLSearchParams(linkUrl.search);

            currentParams.delete('annotation_categories');
            currentParams.delete('search_query');

            for (const [key, value] of params.entries()) {
                if (key !== 'page_number' && !currentParams.has(key)) {
                    currentParams.set(key, value);
                }
            }

            linkUrl.search = currentParams.toString();

            link.href = linkUrl.href;
        });
        this.applyToGoToPageFormSubmit(params)
    },
    applyToGoToPageFormSubmit(params) {
        const form = document.getElementById('pagination-go-to-page');
        if (!form) {
            return;
        }

        const input = form.querySelector('input[name="page_number"]');
        if (!input) {
            return;
        }

        const currentParams = new URLSearchParams(window.location.search);

        for (const [key, value] of params.entries()) {
            if (!currentParams.has(key)) {
                currentParams.set(key, value);
            }
        }
        if (currentParams.has('search_query')) {
            currentParams.delete('search_query');
        }

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            console.log('form submitted');
            const page = input.value;
            const url = new URL(window.location);
            url.search = currentParams.toString();
            url.searchParams.set('page_number', page);
            window.location.href = url.href;
        });
    }
}));
